import Vue from "vue";
import pinia from "@/vue/shared/store";
import { getTerminal } from '@shared/utils';
import { TERMINAL } from "@shared/constants";
import Address from "./Address.vue";

export default new Vue({
  el: "#pc-cart-address-mount",
  pinia,
  render: (h) => h(Address),
});